/* LogoutSectionRenderer.js */

"use strict";

const ContentBar = require("../login/contentbar/ContentBarComponent");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class LogoutSectionRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("logout-section-gl");
        this._logoutContainer = document.createElement("logout-container");
        this._logoutContentContainer = document.createElement("logout-content-container");
        this._brandingContainer = document.createElement("branding-container-gl");
        this._controlsContainer = document.createElement("controls-container-gl");
        this._messageComponent = document.createElement("div");
        this._loginLogo = document.createElement("login-logo-gl");
        this._loginBtn = new ButtonControl({
            label: "Sign Back In",
            active: true,
            disabled: false,
        });

        this._onLoginBtnUserClick = this._onLoginBtnUserClick.bind(this);
        this._shutdown = this._shutdown.bind(this);
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        this._unregisterListeners();
        let promArr = [this._loginBtn.shutdown(), this._contentBar.shutdown()];
        return Promise.all(promArr)
            .then(() => {
                this._messageComponent.removed();
                this._messageComponent = undefined;
                this._loginLogo.removed();
                this._loginLogo = undefined;
                this._brandingContainer.removed();
                this._brandingContainer = undefined;
                this._logoutContentContainer.removed();
                this._logoutContentContainer = undefined;
                this._controlsContainer.removed();
                this._controlsContainer = undefined;
                this._logoutContainer.removed();
                this._logoutContainer = undefined;
                this._contentBar = undefined;
                this._loginBtn = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            })
            .catch((err) => {
                console.log("Error shutting down LogoutSectionRenderer: ", err);
            });
    }

    _registerListeners() {
        this._loginBtn.on("UserClick", this._onLoginBtnUserClick);
        this._model.on("Shutdown", this._shutdown);
    }

    _unregisterListeners() {
        this._loginBtn.removeListener("UserClick", this._onLoginBtnUserClick);
        this._model.removeListener("Shutdown", this._shutdown);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._registerListeners();

        this._brandingContainer.appendChild(this._loginLogo);

        this._messageComponent.innerText = "Logged out successfully.";
        this._controlsContainer.appendChild(this._messageComponent);
        this._controlsContainer.appendChild(this._loginBtn.renderer.rootElement);

        this._logoutContentContainer.appendChild(this._brandingContainer);
        this._logoutContentContainer.appendChild(this._controlsContainer);

        this._logoutContainer.appendChild(this._logoutContentContainer);
        this._rootElem.appendChild(this._logoutContainer);

        return Promise.resolve()
            .then(() => {
                return this._model.getContent();
            })
            .then((content) => {
                return this._renderContentBar(content);
            });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onLoginBtnUserClick() {
        location.href = `${window.origin}/session/directToLogin`;
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _renderContentBar(contentItems) {
        this._contentBar = new ContentBar({
            items: contentItems,
            veilContainer: this._logoutContainer,
        });
        this._rootElem.appendChild(this._contentBar.renderer.rootElement);
        return this._contentBar.renderer.render();
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = LogoutSectionRenderer;
